import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// HELPERS
import { logContext, useLogContext } from './helpers/logContext';

// LOCAL PARTS
import LogTab from './parts/LogTab';

// LOCAL TOOLS
import CloseButton from './tools/CloseButton';

// LOGS
import ActivityLog from './types/ActivityLog';
import CommentsLog from './types/CommentsLog';
import DealTasksLog from './types/DealTasksLog';
import SalesLog from './types/SalesLog';

// STYLES
import styles from './logs.module.scss';

// MAIN COMPONENT
const Logs = logContext(({
  logs = {}
}) => {

  // HOOKS
  const { activeLog } = useLogContext();

  // RENDER
  return (<>
    <div className={clsx(
      styles.container,
      !!activeLog && styles.active
    )}>
      <div className={clsx(
        'btn-group',
        styles.tabs
      )}>
        {Object.keys(logs).map((key, i) => {
          const TabComponent = logs[key].Tab || LogTab;
          return <TabComponent key={i} name={key} />
        })}
      </div>
      <div className={styles.list}>
        {Object.keys(logs).map((key, i) => {
          const LogComponent = logs[key];
          return <LogComponent key={i} name={key} />
        })}
      </div>
    </div>
    <CloseButton />
  </>);
});

// CHILD COMPONENTS
Logs.Activity  = ActivityLog;
Logs.Comments  = CommentsLog;
Logs.DealTasks = DealTasksLog;
Logs.Sales     = SalesLog;

// EXPORT
export default Logs;
